module.exports = __webpack_public_path__ + "static/media/actioncy-io-logo.90fcf299.png";


//////////////////
// WEBPACK FOOTER
// ./src/mediaData/actioncy-io-logo.png
// module id = 918
// module chunks = 0